import React from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation } from 'react-router-dom'

import bottlesImg from 'src/assets/images/jar_img.png'
import { Header } from 'src/components'

import styles from './CreateBottle.module.scss'

const CreateBottle = () => {
  const { pathname } = useLocation()
  const { t } = useTranslation()

  const stepMap: { [key: string]: string } = {
    'step-1': '1',
    'step-2': '2',
    'step-3': '3',
    'step-4': '4',
  }

  const numberOfPage = stepMap[pathname.split('/')[2]]
  const isConfirmation = pathname.split('/')[2] === 'confirmation'

  return (
    <>
      {!isConfirmation && (
        <Header variant='settings' setting={t('create_bottle.step', { step: numberOfPage })} color='white' path='..' />
      )}
      {isConfirmation && <Header variant='back' color='white' path='..' />}

      <main className={styles.wrapper}>
        {pathname.split('/')[2] !== 'confirmation' && (
          <div className={styles.wrapper_header}>
            <img src={bottlesImg} alt='Bottle with money' />
          </div>
        )}

        <Outlet />
      </main>
    </>
  )
}

export default CreateBottle
